import TabPanel from "../../../../components/common/TabPanel";
import { Box, Tab, Tabs, Alert, Button } from "@mui/material";
import Schedules from "./schedules";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { fetchConnectStatus } from "../../../../redux/specialist-slices/wallet.slice";
import Exceptions from "./exceptions";

function Index() {
  const dispatch = useDispatch();
  const [value, setValue] = useState("slots");
  const { connectStatus } = useSelector((state) => state.walletSlice);

  const handleChange = (_, value) => { setValue(value) };

  useEffect(() => {
    dispatch(fetchConnectStatus());
  }, [dispatch]);

  const isStripeConnected =
    connectStatus?.connected === true &&
    connectStatus?.chargesEnabled === true &&
    connectStatus?.payoutsEnabled === true &&
    connectStatus?.onboardingComplete === true &&
    !!connectStatus?.stripeAccountId;

  const hasStatusLoaded = connectStatus !== null;
  const showWarningBanner = hasStatusLoaded && !isStripeConnected;

  return (
    <>
      {showWarningBanner && (
        <Alert
          severity="warning"
          sx={{
            mb: 3,
            borderRadius: "12px",
            fontSize: "14px",
            fontWeight: 500,
            display: "flex",
            alignItems: "center",
            "& .MuiAlert-message": {
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexWrap: "wrap",
              gap: 1.5,
            },
          }}
        >
          <span>
            Please connect your bank account from the Earnings &amp; Payouts page to enable adding or editing slots and exceptions.
          </span>
          <Button
            component={Link}
            to="/specialist/profile/wallet"
            variant="contained"
            color="warning"
            size="small"
            sx={{
              textTransform: "none",
              fontWeight: 600,
            }}
          >
            Go to Earnings &amp; Payouts
          </Button>
        </Alert>
      )}

      <Box mb={3}>
        <Tabs
          value={value}
          onChange={handleChange}
          sx={{
            "& .MuiTabs-indicator": {
              display: "none",
            },

            "& .MuiTabs-flexContainer": {
              gap: 2,
            },

            "& .MuiTab-root": {
              minHeight: 46,
              minWidth: 130,
              px: 3,
              py: 1,
              border: "1px solid #D0D7DE",
              borderRadius: "8px",
              backgroundColor: "#fff",
              color: "#6B7280",
              textTransform: "uppercase",
              fontWeight: 600,
              fontSize: "15px",
              fontFamily: "Poppins",
              transition: "all .2s ease",
            },

            "& .MuiTab-root:hover": {
              backgroundColor: "#F5F9FF",
              borderColor: "#2E8DE4",
            },

            "& .MuiTab-root.Mui-selected": {
              backgroundColor: "#2E8DE4",
              color: "#fff",
              borderColor: "#2E8DE4",
            },
          }}
        >
          <Tab label="Slots" value="slots" />
          <Tab label="Exceptions" value="exceptions" />
        </Tabs>
      </Box>
      <TabPanel
        index={value}
        value="slots"
        children={<Schedules />}
      />
      <TabPanel
        index={value}
        value="exceptions"
        children={<Exceptions />}
      />
    </>
  );
};

export default Index;